import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const externalSupportTicketMessageSchema = z.object({
  content: z
    .string({ message: 'Campo obrigatório' })
    .min(3, 'Mínimo de 3 caracteres')
    .max(2048, 'Máximo de 2048 caracteres'),
  documents: z
    .array(
      z.object({
        id: z.string(),
        file: z.custom<File>().optional(),
        fileName: z.string(),
        currentFileUrl: z.string(),
      }),
    )
    .optional(),
})

export type ExternalSupportTicketMessageValidationSchema = z.infer<typeof externalSupportTicketMessageSchema>

export const externalSupportTicketResponsibleSchema = z.object({
  responsible: optionSchema.optional(),
})

export type ExternalSupportTicketResponsibleValidationSchema = z.infer<typeof externalSupportTicketResponsibleSchema>

export const externalSupportTicketSchema = z.intersection(
  z.object({
    reason: optionSchema,
    subject_line: z
      .string({ message: 'Campo obrigatório' })
      .min(3, 'Mínimo de 3 caracteres')
      .max(128, 'Máximo de 128 caracteres'),
    company: optionSchema,
    branch: optionSchema.optional().nullable(),
    branch_type: optionSchema,
  }).superRefine((data, ctx) => {
    if (data.branch_type.value === 'Client::CompanyBranch' && !data?.branch?.value) {
      ctx.addIssue({
        path: ['branch'],
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
      })
    }
  }),
  externalSupportTicketMessageSchema,
)

export type ExternalSupportTicketValidationSchema = z.infer<typeof externalSupportTicketSchema>
